import { render, staticRenderFns } from "./BtnAlterarPrioridadeFormCarga.vue?vue&type=template&id=3b0cb850&"
import script from "./BtnAlterarPrioridadeFormCarga.vue?vue&type=script&lang=js&"
export * from "./BtnAlterarPrioridadeFormCarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports